import React from 'react';
import { useState, useRef } from 'react';
import ContenedorAnimacion from './ContenedorAnimacion';
import Accordion, {AccordionSlots, accordionClasses,} from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails, { accordionDetailsClasses,} from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import ShadowContent from "./ShadowContent";

import  ObtenerPrestadoresEspecialidad from '../functions/ObtenerPrestadoresEspecialidad';

import { InputAdornment, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import SignpostIcon from '@mui/icons-material/Signpost';
import DomainIcon from '@mui/icons-material/Domain';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import CategoryIcon from '@mui/icons-material/Category';
import MedicationIcon from '@mui/icons-material/Medication';


import SeleccionarPais from './SeleccionarPais';
import SeleccionarProvincia from './SeleccionarProvincia';
import SeleccionarLocalidad from './SeleccionarLocalidad';
import SeleccionarEspecialidad from './SeleccionarEspecialidad';
import SeleccionarRubro from './SeleccionarRubro';
import SeleccionarBusqueda from './SeleccionarBusqueda';

import ObtenerPrestadores from '../functions/ObtenerPrestadores';
import ObtenerFarmaciasSancor from '../functions/ObtenerFarmaciasSancor';

import PaisSeleccionar from '../types/PaisSeleccionar';
import ProvinciaSeleccionar from '../types/ProvinciaSeleccionar';
import LocalidadSeleccionar from '../types/LocalidadSeleccionar';
import EspecialidadSeleccionar from '../types/EspecialidadSeleccionar';
import RubroSeleccionar from '../types/RubroSeleccionar';
import BusquedaSeleccionar from '../types/BusquedaSeleccionar';
import PrestadorTabla from '../types/PrestadorTabla';
import ObtenerPrestadorEspecialidades from '../functions/ObtenerPrestadorEspecialidades';
import SeleccionarSancorUbicacion from './SeleccionarSancorUbicacion';
import SancorUbicacionSeleccionar from '../types/SancorUbicacionSeleccionar';
import SancorFarmaciaSeleccionar from '../types/SancorFarmaciaSeleccionar';
import SancorVademecumSeleccionar from '../types/SancorVademecumSeleccionar';
import SancorVademecumOncologicoSeleccionar from '../types/SancorVademecumOncologicoSeleccionar';
import ObtenerVademecumSancor from '../functions/ObtenerVademecumSancor';


interface filtros {
    general: string | null;
    pais: number | null;
    provincia: number | null;
    localidad: number | null;
    localidadTexto: string | null;
    rubro: number | null;
    especialidad: number | null;
    domicilio: string | null;
}

interface farmaciasFiltros {
    texto: string | null;
    localidad: string | null;
    provincia: string | null;
};

const MostrarBuscador = () => {

    const refFiltroBusqueda = useRef<HTMLInputElement>(null);
    const refFiltroFarmacia = useRef<HTMLInputElement>(null);
    const refFiltroVademecum = useRef<HTMLInputElement>(null);

    //const [expanded, setExpanded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [prestadores, setPrestadores] = useState<PrestadorTabla[]>([]);

    const [error, setError] = useState<string | null>(null);
    const [filtroBusqueda, setFiltroBusqueda] = useState<string>('');
    const [filtroDomicilio, setFiltroDomicilio] = useState<string>('');
    
    const [expanded, setExpanded] = React.useState<string | false>('');
    const [prestadoresFiltrados, setPrestadoresFiltrados] = useState<PrestadorTabla[]>([]);

    const [buscando, setBuscando] = useState<number>(0);
    const [busquedaFinalizada, setBusquedaFinalizada] = useState<boolean>(false);

    const [eliminando, setEliminando] = useState<boolean>(false);
    const [mostrarPais, setMostrarPais] = useState<boolean>(false);

    const [localIdPais, setLocalIdPais] = useState(1);
    const [localIdProvincia, setLocalIdProvincia] = useState(1);
    const [localIdLocalidad, setLocalIdLocalidad] = useState(0);
    const [localLocalidad, setLocalLocalidad] = useState<string>('');
    const [localIdEspecialidad, setLocalIdEspecialidad] = useState(0);
    const [localIdRubro, setLocalIdRubro] = useState(0);
    const [localDetalleRubro, setLocalDetalleRubro] = useState<string>('');
    const [localIdBusqueda, setLocalIdBusqueda] = useState(0);
    const [localDetalleBusqueda, setLocalDetalleBusqueda] = useState('');

    const [localIdUbicacion, setLocalIdUbicacion] = useState(0);
    const [farmaciaFiltroTexto, setFarmaciaFiltroTexto] = useState<string>('');
    const [farmaciaFiltroLocalidad, setFarmaciaFiltroLocalidad] = useState<string>('');
    const [farmaciaFiltroProvincia, setFarmaciaFiltroProvincia] = useState<string>('');
    const [farmaciasSancor, setFarmaciasSancor] = useState<SancorFarmaciaSeleccionar[]>([]);

    const [vademecumSancor, setVademecumSancor] = useState<SancorVademecumSeleccionar[]>([]);
    const [vademecumOncologicoSancor, setVademecumOncologicoSancor] = useState<SancorVademecumOncologicoSeleccionar[]>([]);

    const [textoVademecum, setTextoVademecum] = useState<string>('');
    
    
    const [filtros, setFiltros] = useState<filtros>({
        general: null,
        pais: null,
        provincia: null,
        localidad: null,
        localidadTexto: null,
        rubro: null,
        especialidad: null,
        domicilio: null
    });

    const [farmaciasFiltros, setFarmaciasFiltros] = useState<farmaciasFiltros>({
        texto: null,
        localidad: null,
        provincia: null
    });

    const fetchPrestadores = async () => {
        try {
          const data = await ObtenerPrestadores("activos");
          setPrestadores(data.prestadores);
          setError(null);
        } catch (err) {
          setError('Error al obtener los prestadores:' + err);
          setIsLoading(false);
        }
    };

    const filterData = async (data: PrestadorTabla[], filters: filtros) => {
        try {
            // 1. Traigo los prestadores
            const prestadores = await ObtenerPrestadores("activos");
            setPrestadores(prestadores.prestadores);
    
            let filteredPrestadores = prestadores.prestadores;
    
            // 2. Si hay filtro de especialidad, filtrar por los IDs obtenidos
            if (filters.especialidad) {
                try {
                    const prestadoresEspecialidad = await ObtenerPrestadoresEspecialidad(filters.especialidad);
                    if (prestadoresEspecialidad?.prestadores_especialidad) {
                        const prestadoresEspecialidadObject = prestadoresEspecialidad.prestadores_especialidad;

                        const idsPrestadores = prestadoresEspecialidadObject.map((prestador: { prestador_id: number }) => prestador.prestador_id);
                        
                        filteredPrestadores = await filteredPrestadores.filter((prestador: PrestadorTabla) =>
                            idsPrestadores.includes(prestador.id)
                        );
                    }
                } catch (err) {
                    setError('Error al obtener los prestadores por especialidad: ' + err);
                    setIsLoading(false);
                    return [];
                }
            }
    
            // 3. Aplicar los demás filtros
            const result = filteredPrestadores.filter((item: PrestadorTabla) => {
                return (
                    (!filters.general || 
                        item.nombrecomercial.toLowerCase().includes(filters.general.toLowerCase()) || 
                        item.razonsocial.toLowerCase().includes(filters.general.toLowerCase()) || 
                        item.telefono.toLowerCase().includes(filters.general.toLowerCase()) || 
                        item.sitioweb.toLowerCase().includes(filters.general.toLowerCase()) || 
                        item.domicilio.toLowerCase().includes(filters.general.toLowerCase()) || 
                        item.localidad.toLowerCase().includes(filters.general.toLowerCase()) ||
                        item.observaciones.toLowerCase().includes(filters.general.toLowerCase())) &&
                    (!filters.pais || item.idpais === filters.pais) &&
                    (!filters.provincia || item.idprovincia === filters.provincia) &&
                    (!filters.localidad || item.idlocalidad === filters.localidad || (filters.localidadTexto && item.observaciones.toLowerCase().includes(filters.localidadTexto.toLowerCase()))) &&
                    (!filters.rubro || item.idrubro === filters.rubro) &&
                    (!filters.domicilio || item.domicilio.toLowerCase().includes(filters.domicilio.toLowerCase()))
                );
            });
    
            setIsLoading(false);
            setError(null);
            setBusquedaFinalizada(true);
    
            return result;
        } catch (err) {
            setError('Error al obtener los prestadores: ' + err);
            setIsLoading(false);
            return [];
        }
    };

    const filterDataFarmacias = async (filters: farmaciasFiltros) => {
        try {
            // 1. Traigo las farmacias
            const farmacias = await ObtenerFarmaciasSancor(filters);
    
            setIsLoading(false);
            setError(null);
            setBusquedaFinalizada(true);

            return farmacias.farmacias_sancor;
    
        } catch (err) {
            setError('Error al obtener las farmacias: ' + err);
            setIsLoading(false);
            return [];
        }
    };
    

      const updateFiltro = (campo: keyof filtros, valor: string | number | null) => {
        setFiltros((prevFiltros) => ({
          ...prevFiltros, // Copia los filtros actuales
          [campo]: valor, // Actualiza solo el campo especificado
        }));
      };


      const updateFarmaciasFiltro = (campo: keyof farmaciasFiltros, valor: string | number | null) => {
        setFarmaciasFiltros((prevFarmaciasFiltros) => ({
          ...prevFarmaciasFiltros, // Copia los filtros actuales
          [campo]: valor, // Actualiza solo el campo especificado
        }));
      };

    const handleBusquedaClear = () => {
        setLocalIdBusqueda(0);
        setLocalDetalleBusqueda('');
    }

    const handleFiltroBusquedaClear = () => {
        setFiltroBusqueda('');
        updateFiltro('general', null);        
    }

    const handleFiltroDomicilioClear = () => {
        setFiltroDomicilio('');
        updateFiltro('domicilio', null);
    }


    const handleFarmaciaTextoClear = () => {
        setFarmaciaFiltroTexto('');
        updateFarmaciasFiltro('texto', null);
    }

    const handleVademecumTextoClear = () => {
        setTextoVademecum('');
    }

    const handlePaisClear = () => {
        setLocalIdPais(0);
        setLocalIdProvincia(0);
        setLocalIdLocalidad(0);
        updateFiltro('pais', null);
        updateFiltro('provincia', null);
        updateFiltro('localidad', null);
        updateFiltro('localidadTexto', null);
    }

    const handleProvinciaClear = () => {
        setLocalIdProvincia(0);
        setLocalIdLocalidad(0);
        updateFiltro('provincia', null);
        updateFiltro('localidad', null);
        updateFiltro('localidadTexto', null);
    }

    const handleLocalidadClear = () => {
        setLocalIdLocalidad(0);
        updateFiltro('localidad', null);
        updateFiltro('localidadTexto', null);
    }

    const handleEspecialidadClear = () => {
        setLocalIdEspecialidad(0);
        updateFiltro('especialidad', null);
    }

    const handleRubroClear = () => {
        setLocalIdRubro(0);
        setLocalDetalleRubro('');
        updateFiltro('rubro', null);
    }

    const handleSeleccionarBusqueda = (busquedaSeleccionada: BusquedaSeleccionar | null) => {
        setLocalIdBusqueda(busquedaSeleccionada?.id || 0);
        setLocalDetalleBusqueda(busquedaSeleccionada?.busqueda || '');
        if (busquedaSeleccionada?.id === 1) { }
    
    };

    const handleSeleccionarRubro = (rubroSeleccionado: RubroSeleccionar | null) => {
        setLocalIdRubro(rubroSeleccionado?.id || 0);
        setLocalDetalleRubro(rubroSeleccionado?.name || '');
        updateFiltro('rubro', rubroSeleccionado?.id || null);
    };

    const handlePaisChange = (paisSeleccionado: PaisSeleccionar) => {
        setLocalIdPais(paisSeleccionado.id);
        updateFiltro('pais', paisSeleccionado.id);
    }


    const handleProvinciaChange = (provinciaSeleccionada: ProvinciaSeleccionar) => {
        setLocalIdProvincia(provinciaSeleccionada.id);
        updateFiltro('provincia', provinciaSeleccionada.id);
    }

    const handleLocalidadChange = (localidadSeleccionada: LocalidadSeleccionar) => {
        setLocalIdLocalidad(localidadSeleccionada.id);
        updateFiltro('localidad', localidadSeleccionada.id);
        updateFiltro('localidadTexto', localidadSeleccionada.name);
        console.log(localidadSeleccionada.name);
    }

    const handleEspecialidadChange = (especialidadSeleccionada: EspecialidadSeleccionar) => {
        setLocalIdEspecialidad(especialidadSeleccionada.id);
        updateFiltro('especialidad', especialidadSeleccionada.id);
    }

    const handleFiltroBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFiltroBusqueda(event.target.value);
        updateFiltro('general', event.target.value);
    }

    const handleFiltroDomicilioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFiltroDomicilio(event.target.value);
        updateFiltro('domicilio', event.target.value);
    }

    const handleExpansion = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
      };

      const handleUbicacionChange = (ubicacionSeleccionda: SancorUbicacionSeleccionar) => {
        setFarmaciaFiltroProvincia(ubicacionSeleccionda.province);
        setFarmaciaFiltroLocalidad(ubicacionSeleccionda.city);
        updateFarmaciasFiltro('localidad', ubicacionSeleccionda.city);
        updateFarmaciasFiltro('provincia', ubicacionSeleccionda.province);
    }

    const handleFarmaciaFiltroTextoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFarmaciaFiltroTexto(event.target.value);
        updateFarmaciasFiltro('texto', event.target.value);
    }

    const handleVademecumFiltroTextoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTextoVademecum(event.target.value);
    }

    const resetearFiltros = () => {
        setLocalIdBusqueda(0);
        setLocalDetalleBusqueda('');
        
        setLocalIdPais(1);
        updateFiltro('pais', 1);

        setLocalIdProvincia(1);
        updateFiltro('provincia', 1);

        setLocalIdLocalidad(0);
        updateFiltro('localidad', null);

        setLocalLocalidad('')
        updateFiltro('localidadTexto', null);

        setLocalIdRubro(0);
        setLocalDetalleRubro('');
        updateFiltro('rubro', null);

        setLocalIdEspecialidad(0);
        updateFiltro('especialidad', null);

        setFiltroBusqueda('');
        updateFiltro('general', null);

        setFiltroDomicilio('');
        setLocalDetalleRubro('');
        updateFiltro('domicilio', null);

        setBuscando(0);
        setBusquedaFinalizada(false);
        setPrestadoresFiltrados([]);
        setError(null);

        // Limpiar filtros de farmacias
        setFarmaciaFiltroTexto('');
        setFarmaciaFiltroLocalidad('');
        setFarmaciaFiltroProvincia('');
        updateFarmaciasFiltro('texto', null);
        updateFarmaciasFiltro('localidad', null);
        updateFarmaciasFiltro('provincia', null);

        // Limpiar filtros de vademecum
        setTextoVademecum('');

        // Limpiar filtros de vademecum oncologico
        setTextoVademecum('');
    };

    const buscarRegistros = () => {
        // quiero incrementar en uno el valor de buscando
        setBuscando(buscando + 1);      
    };

    React.useEffect(() => {
        // Definimos una función asíncrona para obtener los resultados
        const obtenerResultados = async () => {

            try {
                // Acá filtro los resultados
                const localPrestadores = await filterData(prestadores, filtros);
                if (localPrestadores) {
                    setPrestadoresFiltrados(localPrestadores);
                    setBusquedaFinalizada(true);
                    setBuscando(0);
                    setError(null);
                } else {
                    setPrestadoresFiltrados([]);
                    setBusquedaFinalizada(true);
                    setBuscando(0);
                    setError('No se encontraron prestadores que cumplan con los filtros seleccionados.');
                }
            } catch (err) {
                setError('Error al filtrar los prestadores:' + err);
                setIsLoading(false);
            }
        };

        const obtenerResultadosFarmacias = async () => {
            try {
                // Acá filtro los resultados
                const farmaciasFiltradas = await filterDataFarmacias(farmaciasFiltros);
                if (farmaciasFiltradas) {
                    setFarmaciasSancor(farmaciasFiltradas.pharmacies);
                    setBusquedaFinalizada(true);
                    setBuscando(0);
                    setError(null);
                } else {
                    setFarmaciasSancor([]);
                    setBusquedaFinalizada(true);
                    setBuscando(0);
                    setError('No se encontraron farmacias que cumplan con los filtros seleccionados.');
                }
            } catch (err) {
                setError('Error al filtrar las farmacias:' + err);
                setIsLoading(false);
            }
        };

        const obtenerResultadosVademecumSancor = async (prmTipo: string) => {
            if (textoVademecum.length < 3) {
                setVademecumSancor([]);
                setVademecumOncologicoSancor([]);
                setBusquedaFinalizada(true);
                setBuscando(0);
                setError('Debe ingresar al menos 3 caracteres para realizar la búsqueda.');
                return;
            }
            try {
                // Acá filtro los resultados
                const vademecumFiltrado = await ObtenerVademecumSancor(prmTipo, textoVademecum);
                
                if (vademecumFiltrado) {

                    if (prmTipo === 'vademecum') {
                        setVademecumSancor(vademecumFiltrado.vademecum_sancor.vademecums);
                    } else {
                        setVademecumOncologicoSancor(vademecumFiltrado.vademecum_sancor.vademecumOncologies);
                    }
                    setBusquedaFinalizada(true);
                    setBuscando(0);
                    setError(null);
                } else {
                    setVademecumSancor([]);
                    setVademecumOncologicoSancor([]);
                    setBusquedaFinalizada(true);
                    setBuscando(0);
                    setError('No se encontraron medicamentos que cumplan con los filtros seleccionados.');
                }
            } catch (err) {
                setVademecumSancor([]);
                setVademecumOncologicoSancor([]);
                setBusquedaFinalizada(true);
                setBuscando(0);
                setError('Error al filtrar el vademecum:' + err);
                setIsLoading(false);
            }
        };


        if (localIdBusqueda === 1) obtenerResultados();
        if (localIdBusqueda === 2) obtenerResultadosFarmacias();
        if (localIdBusqueda === 3) obtenerResultadosVademecumSancor('vademecum');
        if (localIdBusqueda === 4) obtenerResultadosVademecumSancor('vademecum_oncologico');

        if (localIdBusqueda === 1) refFiltroBusqueda.current?.focus();
        if (localIdBusqueda === 2) refFiltroFarmacia.current?.focus();
        if (localIdBusqueda === 3 || localIdBusqueda === 4) refFiltroVademecum.current?.focus();                    

    }, [buscando]);
    
    //}, [filtroBusqueda, filtroDomicilio, localIdPais, localIdProvincia, localIdLocalidad, localIdRubro, localIdEspecialidad, localIdBusqueda, prestadores, filtros]);

    return (
        <section id="Buscador" className="bg-white pt-[60px] text-white">
            <div className="flex flex-col pt-8 pb-4 px-4 mx-auto max-w-screen-2xl text-center">
                <ContenedorAnimacion animation='slideInLeft' duration={800} delay={1} className="">
                    <div className="flex flex-col items-center mx-auto max-w-screen-2xl space-y-3">
                        <h2 className="font-metropolis mb-4 text-4xl tracking-tight font-regular text-gray-900 ">Buscador de Servicios y Beneficios</h2>
                        <h3 className="font-metropolis font-regular text-gray-600 sm:text-xl ">Encontrá servicios, profesionales y beneficios que te brinda VidaPlus.</h3>
                        <div className="flex flex-row justify-end items-center flex-grow w-[90%] flex-wrap sm:flex-nowrap space-x-0 sm:space-x-3">
                            <div className="flex flex-col justify-between items-start flex-grow w-[100%]">
                                <SeleccionarBusqueda busquedaInicial={localIdBusqueda} onChange={handleSeleccionarBusqueda} onClear={handleBusquedaClear} eliminando={eliminando}/>                                
                            </div>
                            {localIdBusqueda === 1 && (
                                <div className="flex flex-col justify-between items-start flex-grow w-[100%] pt-2">
                                <TextField
                                    inputRef={refFiltroBusqueda}
                                    id="filtroBusqueda"
                                    label="Buscar..."
                                    variant="outlined"
                                    className="w-full mt-4"
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0px',
                                        },
                                        width: '100%',
                                        minWidth: '280px',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),  
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            {filtroBusqueda && (
                                            <IconButton onClick={handleFiltroBusquedaClear} edge="end">
                                                <ClearIcon />
                                            </IconButton>
                                            )}
                                        </InputAdornment>
                                        ),
                                    }}
                                    onChange={handleFiltroBusquedaChange}
                                    value={filtroBusqueda}
                                    autoFocus
                                />
                            </div>)}
                            <div className="flex flex-col mb-1 xxs:mt-3 xs:mt-3">
                                <button className="vp-btn-azul-sm w-full shadow-md shadow-vp-gris" onClick={resetearFiltros}>Limpiar filtros</button>
                            </div>
                        </div>
                        {localIdBusqueda === 1 &&
                        (
                         <div className="flex flex-col justify-center items-center flex-grow w-[90%]">
                            <div className="flex flex-col justify-between items-start flex-grow w-full mb-2">
                                <h3 className="font-metropolis font-regular text-gray-600 sm:text-xl ">Filtros:</h3>
                            </div>
                            <div className="flex flex-row justify-between items-start flex-grow w-full flex-wrap sm:flex-nowrap space-x-0 sm:space-x-3">
                                <div className="flex flex-col justify-between items-center flex-grow w-[250px] mb-2">                            
                                    {mostrarPais === true && (<div className="flex flex-col justify-between items-center flex-grow w-full mb-2">
                                        <SeleccionarPais paisInicial={localIdPais} onChange={handlePaisChange} onClear={handlePaisClear} eliminando={eliminando}/>
                                    </div>)}
                                    <div className="flex flex-col justify-between items-center flex-grow w-full mb-2">
                                        <SeleccionarProvincia paisInicial={localIdPais} provinciaInicial={localIdProvincia} onChange={handleProvinciaChange} onClear={handleProvinciaClear} eliminando={eliminando}/>
                                    </div>
                                    <div className="flex flex-col justify-between items-center flex-grow w-full mb-2">
                                        <SeleccionarLocalidad paisInicial={localIdPais} provinciaInicial={localIdProvincia} localidadInicial={localIdLocalidad} onChange={handleLocalidadChange} onClear={handleLocalidadClear} eliminando={eliminando}/>
                                    </div>
                                </div>
                                <div className="flex flex-col justify-between items-center flex-grow w-[250px] mb-2">                            
                                    <div className="flex flex-col justify-between items-center flex-grow w-full mb-2">
                                        <SeleccionarRubro rubroInicial={localIdRubro} onChange={handleSeleccionarRubro} onClear={handleRubroClear} eliminando={eliminando}/>   
                                    </div>
                                    <div className="flex flex-col justify-between items-center flex-grow w-full mb-2">
                                        {localIdBusqueda !== 1 ? (
                                            <div></div>
                                        ) : (
                                            <SeleccionarEspecialidad especialidadInicial={localIdEspecialidad} onChange={handleEspecialidadChange} onClear={handleEspecialidadClear} eliminando={eliminando}/>
                                        )}
                                    </div>
                                    <div className="flex flex-col justify-between items-center flex-grow w-full mt-1">
                                        <TextField
                                            id="filtroDomicilio"
                                            label="Domicilio"
                                            variant="outlined"
                                            className="w-full mt-4"
                                            sx={{
                                                '& .MuiOutlinedInput-input': {
                                                    padding: '8px',
                                                },
                                                '& .MuiInputLabel-outlined': {
                                                    top: '-6px',
                                                },
                                                '& .MuiInputLabel-shrink': {
                                                    top: '0px',
                                                },
                                                width: '100%',
                                                minWidth: '280px',
                                                marginRight: '6px',
                                                marginBottom: '8px',
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SignpostIcon />
                                                    </InputAdornment>
                                                ),  
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    {filtroDomicilio && (
                                                    <IconButton onClick={handleFiltroDomicilioClear} edge="end">
                                                        <ClearIcon />
                                                    </IconButton>
                                                    )}
                                                </InputAdornment>
                                                ),
                                            }}
                                            onChange={handleFiltroDomicilioChange}
                                            value={filtroDomicilio}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col flex-grow w-full justify-start items-end">
                                <button className="flex justify-end vp-btn-azul-sm shadow-md shadow-vp-gris" onClick={buscarRegistros}><SearchIcon fontSize='small' className="mr-1" />Buscar</button>
                            </div>
                        </div>
                        )}
                        {localIdBusqueda === 2 &&
                        (
                         <div className="flex flex-col justify-center items-center flex-grow w-[90%]">
                            <div className="flex flex-col justify-between items-start flex-grow w-full mb-2">
                                <h3 className="font-metropolis font-regular text-gray-600 sm:text-xl ">Filtros:</h3>
                            </div>
                            <div className="flex flex-row justify-between items-center flex-grow w-full flex-wrap sm:flex-nowrap space-x-0 sm:space-x-3">
                                <div className="flex flex-row justify-between items-center flex-grow mb-2 xxs:flex-wrap xs:flex-wrap sm:flex-wrap lg:flex-nowrap lg:space-x-3">                            
                                    <div className="flex flex-col justify-between items-center flex-grow w-full">
                                        <SeleccionarSancorUbicacion onChange={handleUbicacionChange} onClear={handlePaisClear} eliminando={eliminando}/>
                                    </div>
                                    <div className="flex flex-col justify-between items-center flex-grow w-full pt-2">
                                        <TextField
                                            inputRef={refFiltroFarmacia}
                                            id="filtroTexto"
                                            label="Nombre / Domicilio"
                                            variant="outlined"
                                            className="w-full"
                                            sx={{
                                                '& .MuiOutlinedInput-input': {
                                                    padding: '8px',
                                                },
                                                '& .MuiInputLabel-outlined': {
                                                    top: '-6px',
                                                },
                                                '& .MuiInputLabel-shrink': {
                                                    top: '0px',
                                                },
                                                width: '100%',
                                                minWidth: '280px',
                                                marginRight: '6px',
                                                marginBottom: '8px',
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SignpostIcon />
                                                    </InputAdornment>
                                                ),  
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    {filtroDomicilio && (
                                                    <IconButton onClick={handleFarmaciaTextoClear} edge="end">
                                                        <ClearIcon />
                                                    </IconButton>
                                                    )}
                                                </InputAdornment>
                                                ),
                                            }}
                                            onChange={handleFarmaciaFiltroTextoChange}
                                            value={farmaciaFiltroTexto}
                                            autoFocus
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col flex-grow w-full justify-start items-end">
                                <button className="flex justify-end vp-btn-azul-sm shadow-md shadow-vp-gris" onClick={buscarRegistros}><SearchIcon fontSize='small' className="mr-1" />Buscar</button>
                            </div>
                        </div>
                        )}
                        {(localIdBusqueda === 3 || localIdBusqueda === 4) &&
                        (
                         <div className="flex flex-col justify-center items-center flex-grow w-[90%]">
                            <div className="flex flex-col justify-between items-start flex-grow w-full mb-2">
                                <h3 className="font-metropolis font-regular text-gray-600 sm:text-xl ">Filtros:</h3>
                            </div>
                            <div className="flex flex-row justify-between items-center flex-grow w-full flex-wrap sm:flex-nowrap space-x-0 sm:space-x-3">
                                <div className="flex flex-row justify-between items-center flex-grow mb-2 xxs:flex-wrap xs:flex-wrap sm:flex-wrap lg:flex-nowrap lg:space-x-3">                            
                                    <div className="flex flex-col justify-between items-center flex-grow w-full pt-2">
                                        <TextField
                                            inputRef={refFiltroVademecum}
                                            id="filtroVademecum"
                                            label="Monodroga / Nombre Comercial"
                                            variant="outlined"
                                            className="w-full"
                                            sx={{
                                                '& .MuiOutlinedInput-input': {
                                                    padding: '8px',
                                                },
                                                '& .MuiInputLabel-outlined': {
                                                    top: '-6px',
                                                },
                                                '& .MuiInputLabel-shrink': {
                                                    top: '0px',
                                                },
                                                width: '100%',
                                                minWidth: '280px',
                                                marginRight: '6px',
                                                marginBottom: '8px',
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <MedicationIcon />
                                                    </InputAdornment>
                                                ),  
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    {filtroDomicilio && (
                                                    <IconButton onClick={handleVademecumTextoClear} edge="end">
                                                        <ClearIcon />
                                                    </IconButton>
                                                    )}
                                                </InputAdornment>
                                                ),
                                            }}
                                            onChange={handleVademecumFiltroTextoChange}
                                            value={textoVademecum}
                                            autoFocus
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col flex-grow w-full justify-start items-end">
                                <button className="flex justify-end vp-btn-azul-sm shadow-md shadow-vp-gris" onClick={buscarRegistros}><SearchIcon fontSize='small' className="mr-1" />Buscar</button>
                            </div>
                        </div>
                        )}
                    </div>
                </ContenedorAnimacion>
            </div>
            <>
                {(isLoading || buscando) && (
                    <div className="flex flex-col justify-center items-center h-48">
                        <CircularProgress />
                        {localIdBusqueda === 1 && (<h3 className="font-metropolis mt-4 text-lg text-gray-800">Cargando Prestadores...</h3>)}
                        {localIdBusqueda === 2 && (<h3 className="font-metropolis mt-4 text-lg text-gray-800">Cargando Farmacias...</h3>)}
                        {localIdBusqueda === 3 && (<h3 className="font-metropolis mt-4 text-lg text-gray-800">Cargando Vademecum...</h3>)}
                        {localIdBusqueda === 4 && (<h3 className="font-metropolis mt-4 text-lg text-gray-800">Cargando Vademecum Oncológico...</h3>)}
                    </div>
                )}

                {error && (
                    <div className="flex flex-col justify-center items-center">
                        <h3 className="font-metropolis mt-4 text-lg text-gray-800">{error}</h3>
                    </div>
                )}
                {/* Resultados de prestadores */}                
                {!isLoading && busquedaFinalizada && localIdBusqueda === 1 && (prestadoresFiltrados?.length > 0 ? (
                    <div className="flex flex-col flex-grow bg-white justify-center items-center w-full space-y-3 pb-5">
                        {prestadoresFiltrados?.length > 0 && (
                            <div className="xs:w-[95%] sm:w-[92%] md:w-[92%] lg:w-[90%] space-y-4 flex-wrap">
                            {prestadoresFiltrados.map((prestador) => (
                                <div key={prestador.id} className="flex flex-col border rounded-lg p-4 shadow-md bg-gray-100">
                                    <div className="flex flex-row justify-between items-center pb-1 mb-2 border-b-2 border-gray-300">
                                        <p className="text-lg font-semibold text-vp-azul">{prestador.nombrecomercial}</p>
                                    </div>
                                    <div className="flex flex-col justify-start items-start pb-1 mb-1">
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Localidad:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{prestador.localidad}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Provincia:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{prestador.provincia}</p>
                                            </div>
                                        </div>
                                        {prestador.domicilio.trim().length !== 0 && (
                                        <>
                                            <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Domicilio:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{prestador.domicilio}</p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.telefono.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Teléfono:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                            <p className="text-gray-700 text-sm">
                                                {prestador.telefono.split(";").map((tel, index) => (
                                                    <a
                                                    key={index}
                                                    href={`tel:${tel.trim()}`}
                                                    className="text-blue-500 hover:underline mr-1"
                                                    >
                                                    {tel.trim()}
                                                    </a>
                                                ))}
                                            </p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.whatsapp.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">WhatsApp:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm"><a href={`https://wa.me/549${prestador.whatsapp}`} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{prestador.whatsapp}</a></p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.sitioweb.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Sitio Web:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm"><a href={prestador.sitioweb} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{prestador.sitioweb}</a></p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.email.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Email:</p>
                                            </div>
                                            <div className="flex flex-row ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm flex flex-row flex-wrap">
                                                    {prestador.email.split(";").map((email, index) => (
                                                        <a
                                                        key={index}
                                                        href={`mailto:${email.trim()}`}
                                                        className="text-blue-500 hover:underline mr-1"
                                                        >
                                                        {email.trim()}
                                                        </a>
                                                    ))}
                                                </p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.instagram.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Instagram:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm"><a href={prestador.instagram} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{prestador.instagram}</a></p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.facebook.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Facebook:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm"><a href={prestador.facebook} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{prestador.facebook}</a></p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.youtube.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Youtube:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm"><a href={prestador.youtube} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{prestador.youtube}</a></p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.tiktok.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">TikTok:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm"><a href={prestador.tiktok} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{prestador.tiktok}</a></p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.linkedin.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">LinkedIn:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm"><a href={prestador.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{prestador.linkedin}</a></p>
                                            </div>
                                        </div>
                                        </>)}
                                        {prestador.observaciones.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-col justify-start items-start mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Observaciones:</p>
                                            </div>
                                            <div className="flex flex-col w-full flex-grow text-black text-sm ml-2">
                                                <ShadowContent htmlContent={prestador.observaciones} />
                                            </div>
                                        </div>
                                        </>)}

                                    </div>
                                </div>
                            ))}
                            </div>
                        )}
                    </div>) : (
                    <div className="flex flex-col justify-center items-center">
                        <h3 className="font-metropolis mt-4 text-lg text-gray-800">No se encontraron prestadores que cumplan con los filtros seleccionados.</h3>
                    </div>
                    )
                )}           
                {/* Resultados de farmacias sancor */}
                {!isLoading && busquedaFinalizada && localIdBusqueda === 2 && (farmaciasSancor?.length > 0 ? (
                    <div className="flex flex-col flex-grow bg-white justify-center items-center w-full space-y-3 pb-5">
                        {farmaciasSancor?.length > 0 && (
                            <div className="xs:w-[95%] sm:w-[92%] md:w-[92%] lg:w-[90%] space-y-4 flex-wrap">
                            {farmaciasSancor.map((farmacia) => (
                                <div key={farmacia.id} className="flex flex-col border rounded-lg p-4 shadow-md bg-gray-100">
                                    <div className="flex flex-row justify-between items-center pb-1 mb-2 border-b-2 border-gray-300">
                                        <p className="text-lg font-semibold text-vp-azul">{farmacia.name}</p>
                                    </div>
                                    <div className="flex flex-col justify-start items-start pb-1 mb-1">
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Localidad:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{farmacia.city}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Provincia:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{farmacia.province}</p>
                                            </div>
                                        </div>
                                        {farmacia.address.trim().length !== 0 && (
                                        <>
                                            <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Domicilio:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{farmacia.address}</p>
                                            </div>
                                        </div>
                                        </>)}
                                        {farmacia.phoneNumber.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Teléfono:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                            <p className="text-gray-700 text-sm">
                                                {farmacia.phoneNumber.split(";").map((tel, index) => (
                                                    <a
                                                    key={index}
                                                    href={`tel:${tel.trim()}`}
                                                    className="text-blue-500 hover:underline mr-1"
                                                    >
                                                    {tel.trim()}
                                                    </a>
                                                ))}
                                            </p>
                                            </div>
                                        </div>
                                        </>)}
                                    </div>
                                </div>
                            ))}
                            </div>
                        )}
                    </div>) : (
                    <div className="flex flex-col justify-center items-center">
                        <h3 className="font-metropolis mt-4 text-lg text-gray-800">No se encontraron farmacias que cumplan con los filtros seleccionados.</h3>
                    </div>
                    )
                )}           
                {/* Resultados de vademecum sancor */}
                {!isLoading && busquedaFinalizada && localIdBusqueda === 3 && (vademecumSancor?.length > 0 ? (
                    <div className="flex flex-col flex-grow bg-white justify-center items-center w-full space-y-3 pb-5">
                        {vademecumSancor?.length > 0 && (
                            <div className="xs:w-[95%] sm:w-[92%] md:w-[92%] lg:w-[90%] space-y-4 flex-wrap">
                            {vademecumSancor.map((medicamento) => (
                                <div key={medicamento.id} className="flex flex-col border rounded-lg p-4 shadow-md bg-gray-100">
                                    <div className="flex flex-row justify-between items-center pb-1 mb-2 border-b-2 border-gray-300">
                                        <p className="text-lg font-semibold text-vp-azul">{medicamento.brand}</p>
                                    </div>
                                    <div className="flex flex-col justify-start items-start pb-1 mb-1">
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Monodroga:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{medicamento.mainDrug}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Presentación:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{medicamento.presentation}</p>
                                            </div>
                                        </div>
                                        {medicamento.potency.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Potencia:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{medicamento.potency}</p>
                                            </div>
                                        </div>
                                        </>)}
                                        {medicamento.contents.trim().length !== 0 && (
                                        <>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Contenido:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{medicamento.contents}</p>
                                            </div>
                                        </div>
                                        </>)}
                                    </div>
                                </div>
                            ))}
                            </div>
                        )}
                    </div>) : (
                    <div className="flex flex-col justify-center items-center">
                        <h3 className="font-metropolis mt-4 text-lg text-gray-800">No se encontraron medicamentos que cumplan con los filtros seleccionados.</h3>
                    </div>
                    )
                )}
                {/* Resultados de vademecum oncológico sancor */}
                {!isLoading && busquedaFinalizada && localIdBusqueda === 4 && (vademecumOncologicoSancor?.length > 0 ? (
                    <div className="flex flex-col flex-grow bg-white justify-center items-center w-full space-y-3 pb-5">
                        {vademecumOncologicoSancor?.length > 0 && (
                            <div className="xs:w-[95%] sm:w-[92%] md:w-[92%] lg:w-[90%] space-y-4 flex-wrap">
                            {vademecumOncologicoSancor.map((medicamento) => (
                                <div key={medicamento.id} className="flex flex-col border rounded-lg p-4 shadow-md bg-gray-100">
                                    <div className="flex flex-row justify-between items-center pb-1 mb-2 border-b-2 border-gray-300">
                                        <p className="text-lg font-semibold text-vp-azul">{medicamento.monoDrug} {medicamento.presentation}</p>
                                    </div>
                                    <div className="flex flex-col justify-start items-start pb-1 mb-1">
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Monodroga:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{medicamento.monoDrug}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-row justify-start items-center mb-1 flex-grow w-full xxs:flex-wrap xs:flex-wrap flex-nowrap">
                                            <div className="flex flex-col">
                                                <p className="text-gray-700 text-sm font-bold whitespace-nowrap">Presentación:</p>
                                            </div>
                                            <div className="flex flex-col ml-1 w-full flex-grow">
                                                <p className="text-gray-700 text-sm">{medicamento.presentation}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            </div>
                        )}
                    </div>) : (
                    <div className="flex flex-col justify-center items-center">
                        <h3 className="font-metropolis mt-4 text-lg text-gray-800">No se encontraron medicamentos oncológicos que cumplan con los filtros seleccionados.</h3>
                    </div>
                    )
                )}           
            </>
        </section>
    );
};

export default MostrarBuscador;